import {z} from 'zod'

import {apiFetch} from '../api/fetch'
import {toApiDateString} from '../jobs/job-schedule-format'
import {
    type DispatchAttentionCount,
    dispatchAttentionCountSchema,
    type DispatchBoardJob,
    dispatchBoardJobResponseSchema,
    type DispatchBoardResponse,
    dispatchBoardResponseSchema,
    type DispatchYard,
    dispatchYardSchema,
    setProjectDispatchYardRequestSchema,
} from './schemas'

export async function getDispatchAttentionCount(): Promise<DispatchAttentionCount> {
    const raw = await apiFetch<unknown>('/dispatch/attention-count')
    return dispatchAttentionCountSchema.parse(raw)
}

type GetDispatchBoardOptions = {
    startDate: Date | string
    endDate?: Date | string
}

export async function getDispatchBoard({
    startDate,
    endDate,
}: GetDispatchBoardOptions): Promise<DispatchBoardResponse> {
    const params = new URLSearchParams({
        start_date: toApiDateString(startDate),
    })

    if (endDate != null) {
        params.set('end_date', toApiDateString(endDate))
    }

    const raw = await apiFetch<unknown>(`/dispatch/board?${params.toString()}`)
    return dispatchBoardResponseSchema.parse(raw)
}

export async function getDispatchBoardJob(jobId: string): Promise<DispatchBoardJob> {
    const raw = await apiFetch<unknown>(`/dispatch/board/jobs/${jobId}`)
    return dispatchBoardJobResponseSchema.parse(raw)
}

export async function markDispatchWorkerAssignmentNotified(
    jobId: string,
    assignmentId: string,
): Promise<DispatchBoardJob> {
    const raw = await apiFetch<unknown>(
        `/dispatch/board/jobs/${jobId}/worker-assignments/${assignmentId}/notify`,
        {method: 'POST'},
    )
    return dispatchBoardJobResponseSchema.parse(raw)
}

export async function listDispatchYards(): Promise<DispatchYard[]> {
    const raw = await apiFetch<unknown>('/dispatch/yards')
    return z.array(dispatchYardSchema).parse(raw)
}

export async function setProjectDispatchYard(
    projectId: string,
    dispatchYardId: string,
): Promise<void> {
    const body = setProjectDispatchYardRequestSchema.parse({dispatchYardId})
    await apiFetch<unknown>(`/projects/${projectId}/dispatch-yard`, {
        method: 'PUT',
        body: JSON.stringify(body),
    })
}
